export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6226.389db433.jpg";